/* ============================================================
   DEVICE CLASS — derive the body classes that drive the mobile
   layout from media-query results. Pure so it's unit-testable;
   the effect in TvProvider just applies what this returns.
   ============================================================ */

export interface DeviceMatches {
  coarse: boolean // (pointer: coarse) — a touch primary input
  portrait: boolean // (orientation: portrait)
}

/** The body classes for a given device state. `is-touch` gates all mobile affordances. */
export function deviceBodyClasses(m: DeviceMatches): string[] {
  const out: string[] = []
  if (m.coarse) out.push('is-touch')
  if (m.portrait) out.push('is-portrait')
  return out
}
